import { useState } from 'react';
import { Grid2 as Grid, Container, Typography, Button } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';

import MainFooter from '../../components/layout/MainFooter';
import StepsForgotPass from '../../components/auth/StepsForgotPass';
import FormForgotPass from '../../components/auth/FormForgotPass';
import FormForgetPass2 from '../../components/auth/FormForgetPass2';
import FormForgetPass3 from '../../components/auth/FormForgetPass3';

import { useSelector } from 'react-redux';
import CrearPass from '../../components/auth/CrearPass';

const ForgotPass = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const [value, setValue] = useState('celular');
  const [pasos, setPasos] = useState(1);
  const [data, setData] = useState({
    tel: '',
    prefijo: '52',
    email: '',
    codigo: '' //el codigo que se genera por email
  });
  const [codigo, setCodigo] = useState(''); // el codigo que ingresa el usuario

  //Redirect
  if (isAuthenticated) {
    return <Navigate to="/" />
  }

  /******Olvidar contraseña**********/
  const [exito, setExito] = useState(false);
  const img = exito ? "/Sticker.png" : "/Vector.png";
  const title = exito ? "Contraseña actualizada" : "Ocurrió un error";
  const subTitle = exito ? "Su contraseña ha sido cambiada con éxito." : "¡Upps! ha ocurrido un error intenta de nuevo.";

  return (
    <Container component="main" maxWidth="lg">
      {
        pasos === 5 ? (
          <Grid className="general" container>
            <Grid className="status" item container direction="column" alignItems="center" justifyContent="center" xs={6}>
              <img width="150" src={img} alt="Estatus" />
            </Grid>
            <Grid item container direction="column" alignItems="center" justifyContent="center">
              <Typography variant="h4">{title}</Typography>
              <Typography variant="h5">{subTitle}</Typography>
            </Grid>
            <Grid item xs={6} sx={{ mt: 3 }}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => navigate('/')}
              >
                Entrar
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid className="container-steps" container spacing={{ lg: 3 }}>
            <StepsForgotPass
              pasos={pasos}
            />
            <Grid className={pasos <= 3 ? "form-steps" : "form-password"} size={{ xs: 12, lg: 6 }}>
              {
                pasos === 1 ? (
                  <FormForgotPass
                    setPasos={setPasos}
                    setValue={setValue}
                    value={value}
                    navigate={navigate}
                  />
                ) : pasos === 2 ? (
                  <FormForgetPass2
                    type={value}
                    data={data}
                    setData={setData}
                    setPasos={setPasos}
                    navigate={navigate}
                  />
                ) : pasos === 3 ? (
                  <FormForgetPass3
                    type={value}
                    codigo={codigo}
                    data={data}
                    setCodigo={setCodigo}
                    setPasos={setPasos}
                  />
                ) : pasos === 4 && (
                  <CrearPass
                    navigate={navigate}
                    setPasos={setPasos}
                    setExito={setExito}
                    dataParent={data}
                  />
                )
              }
            </Grid>
          </Grid>
        )
      }
      <MainFooter />
    </Container>
  );
}

export default ForgotPass;
